<div class="col-lg-12">
    <app-phx-data-table [columns]="columns" [configuration]="dataTableConfiguration"
        [dataSourceUrl]="datasourceurl" [dataSourceParams]='odataParams'
        [exportFileName]="'transactions'" [componentName]="'WOActivityTransaction'" (rowClick)="onRowSelected($event)" (contextMenuPreparing)="onContextMenuPreparing($event)">
    </app-phx-data-table>
</div>